module.exports = __webpack_public_path__ + "static/android-chrome-512x512-06a4926d1307e15a9cb7d800546be10d.png";